import logoNoronCar from '../Images/logo.png'
import config from "../config.json";
import "./Register.css";
import loginLogo from '../Images/logoWeb.png'
import React, { useContext, useEffect, useState, useRef } from "react";
import AddImage from '../Images/AddImage.png'
import { Link } from 'react-router-dom';
import http from "../Services/httpService";
import service from "../Services/services";
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import ConfirmDialog from './ConfirmDialog'
import form1 from '../Images/form1.jpg'
import form2 from '../Images/form2.jpg'
export default function RequestInsurance() {
    let navigate = useNavigate();


    const backgroundCardMeli = useRef(null);
    const picCardMeli = useRef(null);

    const backgroundPersoneli = useRef(null);
    const picPersoneli = useRef(null);

    const [form, setForm] = useState({ id: 0, name: "", family: "", detail: [] })
    const [ozveSetting, setOzveSetting] = useState({ vam: "" })
    const [isLoadingSetting, setIsLoadingSetting] = useState(false)
    const getSetting = async () => {
        setIsLoadingSetting(true);
        await service.SettingGet()
            .then(({ data }) => {
                setIsLoadingSetting(false);
                /*if (data.errorCode != 0) {
                  toast.error(data.message, { theme: "colored" });
                  return
                }*/
                setOzveSetting(data);
            })
            .catch(err => {
                setIsLoadingSetting(false);
            });
    }

    const [isLoading, setIsLoading] = useState(false)
    const [dataUser, setDataUser] = useState({ id: 0, name: "", family: "" })
    const loadData = async () => {
        setIsLoading(true);
        await service.OzveGet()
            .then(({ data }) => {
                setIsLoading(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                setDataUser(data.payload);
                setForm({
                    ...form,
                    name: data.payload.name,
                    family: data.payload.family,
                    nameFather: data.payload.nameFather,
                    code: data.payload.code,
                    codeMeli: data.payload.codeMeli,
                    birthDay: data.payload.birthDay,
                    mostamariCode: data.payload.mostamariCode,
                })
            })
            .catch(err => {
                setIsLoading(false);
            });
    }
    useEffect(() => {
        const jwt = http.getLocalJwt();
        if (!jwt || jwt == "") {
            navigate('/login');
            return;
        }
        getSetting();
        loadData();
    }, []);


    const upload = (e, background, name) => {
        const { files } = e.target;
        if (files.length === 0) {
            return;
        }
        if (background) {
            const fileReader = new FileReader();
            fileReader.onload = () => {
                //style={{ backgroundImage: `url(${travelDetailPic})` }}            
                background.current.style.backgroundImage = `url(${fileReader.result})`;
            };
            fileReader.readAsDataURL(files[0]);
        }
        setForm({ ...form, [name]: e.target.files[0] })
    }

    const formRef = useRef(null);
    const form2Ref = useRef(null)
    const [showModal, setShowModal] = useState(false)
    const [formDetail, setFormDetail] = useState({})
    const addDetail = (e) => {
        e.preventDefault();
        setFormDetail({});
        setShowModal(true);
    }

    const doAddDetail = (e) => {
        e.preventDefault();
        const forms = form2Ref.current;
        if (forms.checkValidity() === false) {
            toast.error('داده های ورودی را بررسی بفرمایید', { theme: "colored" });
            forms.classList.add('was-validated')
            return;
        }
        const temp = { ...form };
        temp.detail = [...temp.detail, formDetail];
        setForm(temp);
        setFormDetail({});
        setShowModal(false);
    }

    const doDeleteDetailItem = (e, item, index) => {
        const temp = { ...form };
        temp.detail = temp.detail.filter((x, i) => i != index);
        setForm(temp);
    }

    const [isPosting, setIsPosting] = useState(false)
    const doPostFinall = async (e) => {
        setIsPosting(true);
        await service.RequestInsurance(form)
            .then(({ data }) => {
                setIsPosting(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                toast.dark('درخواست شما ثبت شد');
                navigate('/main');
            })
            .catch(err => {
                setIsPosting(false);
            });
    }
    useEffect(() => {
        console.log('form', form)
    }, [form]);

    return (
        <>

            <ConfirmDialog
                show={showModal}

                title={`ثبت افراد تحت تکفل`}
                handleDo={doAddDetail}
                handleCancel={(e) => setShowModal(false)}
            // isBusy={ }
            >
                <form ref={form2Ref} className=" needs-validation border rounded p-3 mt-3 shadow" >
                    <div className='row p-2'  >
                        <div className="col">
                            <div className="mb-3">
                                <label className="form-label">نام</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    required
                                    value={formDetail.name}
                                    onChange={e => http.handleChange(e, formDetail, setFormDetail)}
                                    name="name" />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">نام خانوادگی</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    required
                                    value={formDetail.family}
                                    onChange={e => http.handleChange(e, formDetail, setFormDetail)}
                                    name="family" />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">نام پدر</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    required
                                    value={formDetail.fatherName}
                                    onChange={e => http.handleChange(e, formDetail, setFormDetail)}
                                    name="fatherName" />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">شماره شناسنامه</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    placeholder=""
                                    value={formDetail.code}
                                    required
                                    onChange={e => http.handleChange(e, formDetail, setFormDetail)}
                                    name="code" />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">کد ملی</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    placeholder=""
                                    required
                                    value={formDetail.codeMeli}
                                    onChange={e => http.handleChange(e, formDetail, setFormDetail)}
                                    name="codeMeli" />
                            </div>


                            <div className="mb-3">
                                <label className="form-label">محل صدور</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    required
                                    value={formDetail.placeBirthName}
                                    onChange={e => http.handleChange(e, formDetail, setFormDetail)}
                                    name="placeBirthName" />
                            </div>


                            <div className="mb-3">
                                <label className="form-label">تاریخ تولد</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    value={formDetail.birthDay}
                                    required
                                    onChange={e => http.handleChange(e, formDetail, setFormDetail)}
                                    name="birthDay" />
                            </div>


                            <div className="mb-3">
                                <label className="form-label">نسبت با بیمه شده</label>
                                <select
                                    className="form-select"
                                    required
                                    value={formDetail.nesbat}
                                    onChange={e => http.handleChange(e, formDetail, setFormDetail)}
                                    name="nesbat" >
                                    <option value="">انتخاب کنید</option>
                                    <option value={0}>مادر</option>
                                    <option value={1}>پدر</option>
                                    <option value={2}>فرزند</option>
                                    <option value={3}>همسر</option>
                                    <option value={4}>سایر</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </form>
            </ConfirmDialog>
            <div className="container  d-flex align-items-center justify-content-center">
                <div className="w-100">
                    <div className="row mt-2 ">
                        <div className="col d-flex  justify-content-center">
                            <img src={loginLogo} className="img-fluid logoRegister" alt="logoRegister" />
                        </div>
                    </div>
                    <div className="row mt-3 ">
                        <div className="col fs-5 text-color1 fw-bold d-flex  justify-content-center">
                            کانون بازنشستگان همدان
                        </div>
                    </div>
                    {(isLoadingSetting || isLoading) &&
                        <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>}

                    <div className="row mt-3 ">
                        <div className="col  border rounded p-3 mt-3 shadow">
                            {!isLoadingSetting &&
                                <div className='row mt-3'>
                                    <div className='col'>
                                        <div className="alert alert-primary" role="alert">
                                            <h4 className="alert-heading">توجه</h4>
                                            مبلغ حق بیمه به اضای هر نفر ، مبلغ {ozveSetting.priceBimeh} می باشد
                                        </div>
                                    </div>
                                </div>
                            }

                            <form ref={formRef} className=" needs-validation " >
                                <div className="row mt-3">
                                    <div className="col d-flex justify-content-center fw-nold fs-5">
                                        بیمه شده اصلی
                                    </div>
                                </div>
                                <div className="row mt-3 rounded border p-3 mx-2">
                                    <div className="col-auto">
                                        <div className="mb-3">
                                            <label className="form-label">نام</label>
                                            <input disabled
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                required
                                                value={form.name}
                                                onChange={e => http.handleChange(e, form, setForm)}
                                                name="name" />
                                        </div>
                                    </div>
                                    <div className="col-auto">
                                        <div className="mb-3">
                                            <label className="form-label">نام خانوادگی</label>
                                            <input disabled
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                required
                                                value={form.family}
                                                onChange={e => http.handleChange(e, form, setForm)}
                                                name="family" />
                                        </div>
                                    </div>
                                    <div className="col-auto">
                                        <div className="mb-3">
                                            <label className="form-label">نام پدر</label>
                                            <input disabled
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                value={form.nameFather}
                                                onChange={e => http.handleChange(e, form, setForm)}
                                                name="nameFather" />
                                        </div>
                                    </div>
                                    <div className="col-auto">
                                        <div className="mb-3">
                                            <label className="form-label">شماره شناسنامه</label>
                                            <input disabled
                                                type="number"
                                                className="form-control"
                                                placeholder=""
                                                value={form.code}
                                                onChange={e => http.handleChange(e, form, setForm)}
                                                name="code" />
                                        </div>
                                    </div>

                                    <div className="col-auto">
                                        <div className="mb-3">
                                            <label className="form-label">کد ملی</label>
                                            <input disabled
                                                type="number"
                                                className="form-control"
                                                placeholder=""
                                                required
                                                value={form.codeMeli}
                                                onChange={e => http.handleChange(e, form, setForm)}
                                                name="codeMeli" />
                                        </div>
                                    </div>
                                    <div className="col-auto">
                                        <div className="mb-3">
                                            <label className="form-label">تاریخ تولد</label>
                                            <input disabled
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                value={form.birthDay}
                                                onChange={e => http.handleChange(e, form, setForm)}
                                                name="birthDay" />
                                        </div>
                                    </div>
                                    <div className="col-auto">
                                        <div className="mb-3">
                                            <label className="form-label">شماره مستمری</label>
                                            <input disabled
                                                type="number"
                                                className="form-control"
                                                placeholder=""
                                                required
                                                value={form.mostamariCode}
                                                onChange={e => http.handleChange(e, form, setForm)}
                                                name="mostamariCode" />
                                        </div>
                                    </div>

                                    <div className="col-auto">
                                        <div className="mb-3">
                                            <label className="form-label">شماره شبا</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                required
                                                value={form.shaba}
                                                onChange={e => http.handleChange(e, form, setForm)}
                                                name="shaba" />
                                        </div>
                                    </div>
                                    <div className="col-auto">
                                        <div className="mb-3">
                                            <label className="form-label">شعبه  </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                required
                                                value={form.shobeh}
                                                onChange={e => http.handleChange(e, form, setForm)}
                                                name="shobeh" />
                                        </div>
                                    </div>
                                    <div className='col-auto'>
                                        <div className='row'>

                                            <div className='col-auto'>
                                                <div className='row'>
                                                    <div className='col'>
                                                        <a href={form1} download="form1">دانلود فرم 1</a>
                                                    </div>
                                                </div>
                                                <div className='row  '>
                                                    <div className='col-auto border rounded m-2   '
                                                        style={{ backgroundSize: "cover" }}
                                                        ref={backgroundPersoneli}>
                                                        <input
                                                            accept="image/*"
                                                            className="d-none"
                                                            type="file"
                                                            onChange={(e) => { upload(e, backgroundPersoneli, "form1") }}
                                                            ref={picPersoneli}
                                                        />

                                                        <div className='row p-4 '>
                                                            <div className='col justify-content-center align-items-center text-center' >
                                                                <div>
                                                                    <Link
                                                                        to=""
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            e.stopPropagation();
                                                                            picPersoneli.current.click()
                                                                        }}>
                                                                        <img src={AddImage} />
                                                                    </Link>
                                                                </div>
                                                                تصویر فرم 1
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>


                                            <div className='col-auto'>
                                                <div className='row'>
                                                    <div className='col'>
                                                        <a href={form2} download="form2">دانلود فرم 2</a>
                                                    </div>
                                                </div>
                                                <div className='row '>
                                                    <div className='col-auto border rounded m-2   '
                                                        style={{ backgroundSize: "cover" }}
                                                        ref={backgroundCardMeli}>
                                                        <input
                                                            accept="image/*"
                                                            className="d-none"
                                                            type="file"
                                                            onChange={(e) => { upload(e, backgroundCardMeli, "form2") }}
                                                            ref={picCardMeli}
                                                        />

                                                        <div className='row p-4 '>
                                                            <div className='col justify-content-center align-items-center text-center' >
                                                                <div>
                                                                    <Link
                                                                        to=""
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            e.stopPropagation();
                                                                            picCardMeli.current.click()
                                                                        }}>
                                                                        <img src={AddImage} />
                                                                    </Link>
                                                                </div>
                                                                تصویر فرم 2
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>

                            </form>
                            <div className='row mt-5'>
                                <div className="col d-flex justify-content-center fw-nold fs-5">
                                    افراد تحت تکفل
                                    <button
                                        onClick={addDetail}
                                        className='ms-2 btn btn-primary'>
                                        اضافه کردن
                                    </button>
                                </div>
                            </div>
                            <div className='row mt-3'>
                                <div className='col rounded border  p-3 mx-2'>
                                    {form.detail.map((x, i) => (
                                        <div className='row rounded border p-2 mt-3 mx-2' key={'r' + i} m>
                                            <div className='col-auto d-flex align-items-center'>
                                                <button
                                                    className='btn btn-danger btn-sm'
                                                    onClick={e => doDeleteDetailItem(e, x, i)}>حذف</button>
                                            </div>
                                            <div className='col'>
                                                <div className='row'>
                                                    <div className="col-auto">
                                                        <div className="mb-3">
                                                            <label className="form-label">نام</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                disabled
                                                                value={x.name}
                                                                //onChange={e => http.handleChange(e, form, setForm)}
                                                                name="name" />
                                                        </div>
                                                    </div>
                                                    <div className="col-auto">
                                                        <div className="mb-3">
                                                            <label className="form-label">نام خانوادگی</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                disabled
                                                                value={x.family}
                                                                //onChange={e => http.handleChange(e, form, setForm)}
                                                                name="family" />
                                                        </div>
                                                    </div>
                                                    <div className="col-auto">
                                                        <div className="mb-3">
                                                            <label className="form-label">نام پدر</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                disabled
                                                                value={x.fatherName}
                                                                //onChange={e => http.handleChange(e, form, setForm)}
                                                                name="fatherName" />
                                                        </div>
                                                    </div>
                                                    <div className="col-auto">
                                                        <div className="mb-3">
                                                            <label className="form-label">شماره شناسنامه</label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                placeholder=""
                                                                disabled
                                                                value={x.code}
                                                                //onChange={e => http.handleChange(e, form, setForm)}
                                                                name="code" />
                                                        </div>
                                                    </div>

                                                    <div className="col-auto">
                                                        <div className="mb-3">
                                                            <label className="form-label">کد ملی</label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                placeholder=""
                                                                disabled
                                                                value={x.codeMeli}
                                                                //onChange={e => http.handleChange(e, form, setForm)}
                                                                name="codeMeli" />
                                                        </div>
                                                    </div>
                                                    <div className="col-auto">
                                                        <div className="mb-3">
                                                            <label className="form-label">محل صدور</label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                placeholder=""
                                                                disabled
                                                                value={x.placeBirthName}
                                                                //onChange={e => http.handleChange(e, form, setForm)}
                                                                name="placeBirthName" />
                                                        </div>
                                                    </div>
                                                    <div className="col-auto">
                                                        <div className="mb-3">
                                                            <label className="form-label">تاریخ تولد</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                disabled
                                                                value={x.birthDay}
                                                                //onChange={e => http.handleChange(e, form, setForm)}
                                                                name="birthDay" />
                                                        </div>
                                                    </div>
                                                    <div className="col-auto">
                                                        <div className="mb-3">
                                                            <label className="form-label">نسبت با بیمه شده</label>
                                                            <select
                                                                className="form-select"
                                                                disabled
                                                                value={x.nesbat}
                                                                //onChange={e => http.handleChange(e, formDetail, setFormDetail)}
                                                                name="nesbat" >
                                                                <option value={0}>مادر</option>
                                                                <option value={1}>پدر</option>
                                                                <option value={2}>فرزند</option>
                                                                <option value={3}>همسر</option>
                                                                <option value={4}>سایر</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>


                            </div>

                            <div className='row mt-3'>
                                <div className='col'>
                                    <button
                                        disabled={isPosting || isLoadingSetting || isLoading}
                                        className='btn btn-success'
                                        onClick={doPostFinall}>
                                        ثبت نهایی
                                        {(isPosting) &&
                                            <div className="spinner-border spinner-border-sm" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-4 mb-4 ">
                            <div className="col d-flex  justify-content-center">
                                <Link to="/main" ><img src={logoNoronCar} className="img-fluid rounded-circle iconLink mx-2 shadow" alt="logoWeb" />بازگشت</Link>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        </>

    );

}
